import OcrListingMapping from 'vcomponents/listing/apiListing/mapping/OcrListingMapping.js';

export default [
    {
        id: 'purchase.incoming',
        label: window.i18n.__('Documents en attente de vérification'),
        buttons: [
            {
                label: window.i18n.__('Importer'),
                primary: true,
                disabled: true,
                type: 'function',
                url: {
                    event: 'openPurchaseImportModal',
                },
                linkedtype: null,
                permission: 'import',
                featureFlag: 'ocr-purchase',
                databot: 'purchases-purinvoices-list_import',
            },
        ],
        enableExport: false,
        enableKpisOnExport: false,
        enableFiltering: false,
        enableOptions: true,
        enableContext: true,
        endpoint: '',
        exportOptions: {},
        favorite: null,
        filter: {},
        filtersComponent: undefined,
        linkedtype: 'ocr',
        name: 'purchase-incoming',
        params: {},
        prefilter: {},
        savedSearchesUrl: '',
        switchDisplay: [],
        url: 'purchases/incoming/search',
        exportUrl: '',
        metaUrl: 'ocr/pur-invoice/metas',
        useFavorites: false,
        group: 'purchase',
        favoritesName: 'purchase-incoming',
        emptyResultPlaceholder: window.i18n.__(
            "Vous n'avez aucun document en attente de vérification",
        ),
        listingMapping: OcrListingMapping,
    },
];
